import { render, staticRenderFns } from "./PopOverSearch.vue?vue&type=template&id=284e2713&scoped=true&"
import script from "./PopOverSearch.vue?vue&type=script&lang=js&"
export * from "./PopOverSearch.vue?vue&type=script&lang=js&"
import style0 from "./PopOverSearch.vue?vue&type=style&index=0&id=284e2713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e2713",
  null
  
)

export default component.exports